import { useSearchParams } from 'react-router-dom';

import {
  parseRequestedOrganizationId,
  resolveOrganizerBlogMembership,
} from '@/components/blog/resolve-organizer-membership';
import ScopedBlogEdit from '@/components/blog/scoped-blog-edit';
import { ROUTES } from '@/config/routes';
import { organizerSidebar } from '@/config/sidebarConfig';
import { useAuthStore } from '@/stores/auth-store';

export default function OrganizerBlogEdit() {
  const user = useAuthStore(s => s.user);
  const [searchParams] = useSearchParams();
  const membership = resolveOrganizerBlogMembership(
    user?.organizationsAdmin,
    parseRequestedOrganizationId(searchParams.get('organizationId')),
  );
  const orgId = membership?.organizationId;
  const listRoute = orgId ? `${ROUTES.ORGANIZER_BLOG}?organizationId=${orgId}` : ROUTES.ORGANIZER_BLOG;

  return (
    <ScopedBlogEdit
      sidebarConfig={organizerSidebar}
      listRoute={listRoute}
      scopePayload={orgId ? { organizationId: orgId } : undefined}
    />
  );
}
